import {
  FaBroom,
  FaChair,
  FaSwimmingPool,
  FaBuilding,
} from "react-icons/fa";
const ServicesData = [
  {
    id: 1,
    title: "Cleaning Service",
    icon: <FaBroom />,
    path: "/cleaning-service",
  },
  {
    id: 2,
    title: "Full House Cleaning",
    icon: <FaBroom />,
    path: "/cleaning-service-details/1",
  },
  {
    id: 3,
    title: "Bathroom Cleaning",
    icon: <FaBroom />,
    path: "/cleaning-service-details/2",
  },
  {
    id: 4,
    title: "Kitchen Cleaning",
    icon: <FaBroom />,
    path: "/cleaning-service-details/3",
  },
  {
    id: 5,
    title: "Carpet Cleaning",
    icon: <FaBroom />,
    path: "/cleaning-service-details/4",
  },
  {
    id: 6,
    title: "Sofa Cleaning",
    icon: <FaChair />,
    path: "/cleaning-service-details/5",
  },
  {
    id: 7,
    title: "Mattress Cleaning",
    icon: <FaChair />,
    path: "/cleaning-service-details/6",
  },
  {
    id: 8,
    title: "Balcony Cleaning",
    icon: <FaBroom />,
    path: "/cleaning-service-details/7",
  },
  {
    id: 9,
    title: "Chair Cleaning",
    icon: <FaChair />,
    path: "/cleaning-service-details/8",
  },
  {
    id: 10,
    title: "Office Cleaning",
    icon: <FaBuilding />,
    path: "/cleaning-service-details/9",
  },
  {
    id: 11,
    title: "Swimming Pool Cleaning",
    icon: <FaSwimmingPool />,
    path: "/cleaning-service-details/10",
  },
  {
    id: 12,
    title: "Window Cleaning",
    icon: <FaBroom />,
    path: "/cleaning-service-details/11",
  },
  
];

export default ServicesData;
